import type { ReactNode } from 'react';

import { useAuth } from '../hooks/useAuth';
import { AccessDenied } from './AccessDenied';

interface RoleGuardProps {
  roles: string[];
  children: ReactNode;
}

export function RoleGuard({ roles, children }: RoleGuardProps) {
  const { user } = useAuth();

  if (!user || !roles.includes(user.role)) {
    return <AccessDenied message="Acesso restrito a administradores." />;
  }

  return <>{children}</>;
}
